export enum DryingSpeed {
  Slow = 1,
  Medium = 2,
  Fast = 3,
  Unknown = 4,
}

export const DryingSpeedString = {
  [DryingSpeed.Slow]: 'inventory.dryingspeedslow',
  [DryingSpeed.Medium]: 'inventory.dryingspeedmedium',
  [DryingSpeed.Fast]: 'inventory.dryingspeedfast',
  [DryingSpeed.Unknown]: 'inventory.dryingspeedunknown',
}
